module.exports = __webpack_public_path__ + "img/hongshu.43226794.png";